import React, { useCallback } from 'react';
import { ModalWindowUI } from '@cube3/ui/src/Modal/ModalWindowUI';
import { useModalActions } from '../Modals/modalActions';
import { StartPage as StartPageUI } from '@cube3/cubicle/src/core/templates/Generative/StartPage';

export const StartPage = () => {
  const { openModal, closeAllModals } = useModalActions();

  const onStartFromScratch = useCallback(() => {
    openModal('generation_modal', false, false);
  }, []);

  const onStartFromBaseImage = useCallback(() => {
    openModal('generation_modal', true, false);
  }, []);

  return (
    <ModalWindowUI hideHeader={true} onCloseEvent={closeAllModals}>
      <StartPageUI
        onClose={closeAllModals}
        onStartFromBaseImage={onStartFromBaseImage}
        onStartFromScratch={onStartFromScratch}
      />
    </ModalWindowUI>
  );
};
